import React, { Fragment } from "react";
import { Button, Select, Option, IconButton } from "@material-tailwind/react";
import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";

export default function Pagination({
    page,
    totalPages,
    limit,
    onChangePage,
    onChangeLimit
}) {

    const getItemProps = (index) =>
    ({
        variant: page === index ? "filled" : "text",
        color: "gray",
        onClick: () => onChangePage(index),
        className: "rounded-full",
    });

    const handlePreviousPage = () => {
        if (page > 1) {
            onChangePage(page - 1);
        }
    };

    const handleNextPage = () => {
        if (page < totalPages) {
            onChangePage(page + 1);
        }
    };

    return (
        <Fragment>
            <hr />
            <div className="flex justify-between items-center mt-4">
                <div className="">
                    <Select label="Rows per page" value={limit} onChange={(value) => onChangeLimit(value)}>
                        <Option value={10}>10</Option>
                        <Option value={20}>20</Option>
                        <Option value={50}>50</Option>
                        <Option value={100}>100</Option>
                    </Select>
                </div>
                <div className="flex items-center gap-4 mt-4">
                    <Button
                        variant="text"
                        className="flex items-center gap-2 rounded-full"
                        onClick={handlePreviousPage}
                        disabled={page === 1}
                    >
                        <ArrowLeftIcon strokeWidth={2} className="h-4 w-4" /> Previous
                    </Button>
                    <div className="flex items-center gap-2">
                        {totalPages <= 5 ? (
                            Array.from({ length: totalPages }, (_, index) => (
                                <IconButton
                                    key={index}
                                    {...getItemProps(index + 1)}
                                    className={`rounded-full ${totalPages > 3 ? 'hidden sm:inline-flex' : ''}`}
                                >
                                    {index + 1}
                                </IconButton>
                            ))
                        ) : (
                            <>
                                {/* Always show first page */}
                                <IconButton
                                    {...getItemProps(1)}
                                    className="rounded-full"
                                >
                                    1
                                </IconButton>
                                {/* Show ellipsis if current page > 3 */}
                                {page > 3 && (
                                    <span className="px-1 text-gray-500 hidden sm:inline">...</span>
                                )}
                                {/* Show up to 3 pages around current page */}
                                {Array.from({ length: 3 }, (_, i) => {
                                    const pageNum = page - 1 + i;
                                    if (pageNum > 1 && pageNum < totalPages) {
                                        return (
                                            <IconButton
                                                key={pageNum}
                                                {...getItemProps(pageNum)}
                                                className="rounded-full"
                                            >
                                                {pageNum}
                                            </IconButton>
                                        );
                                    }
                                    return null;
                                })}
                                {/* Show ellipsis if current page < totalPages - 2 */}
                                {page < totalPages - 2 && (
                                    <span className="px-1 text-gray-500 hidden sm:inline">...</span>
                                )}
                                {/* Always show last page */}
                                <IconButton
                                    {...getItemProps(totalPages)}
                                    className="rounded-full"
                                >
                                    {totalPages}
                                </IconButton>
                            </>
                        )}
                    </div>
                    <Button
                        variant="text"
                        className="flex items-center gap-2 rounded-full"
                        onClick={handleNextPage}
                        disabled={page === totalPages}
                    >
                        Next
                        <ArrowRightIcon strokeWidth={2} className="h-4 w-4" />
                    </Button>
                </div>
            </div>
        </Fragment>
    );
}